// @ts-nocheck 9e51611e
import * as addPanel from '#packages/oldAddPanel';

export default {
  getCategorySections() {
    return addPanel.dataUtil.mergeWithCommonSections(
      addPanel.sections.getSections().page,
      {},
    );
  },
};
